export default __webpack_public_path__ + "static/media/Altius.5109160a.png";